module.exports = __webpack_public_path__ + "static/media/products.c5ffa680.svg";